import React,{useState} from 'react';
import { Card, Box, Typography,Badge, Button,CircularProgress } from '@material-ui/core';
import TelegramIcon from '@material-ui/icons/Telegram';
import ContentCopyIcon from '@material-ui/icons/FileCopy';
import {useAuthContext} from 'src/context/AuthContext';
import {telegramMessage} from 'src/Api.js';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { useAlertContext } from 'src/context/AlertContext';
import { doc} from 'firebase/firestore'; 
import { useFirestoreDocData,useFirestore } from 'reactfire';
import moment from 'moment';
import {sliceIntoChunks} from 'src/utils';
import * as _ from 'lodash';



export const ReportDailyResults = () =>{
  const {useAlert, useErrorAlert} = useAlertContext();
  const {user} = useAuthContext();
  const [telegramReportLoading, setTelegramReportLoading] = useState(false);


  const db = useFirestore();
  const memberCounterRef = doc(db, 'reportCounter',moment().format('MM-DD-YYYY'),'members',user.userId);
  const { status, data: textCounter} = useFirestoreDocData(memberCounterRef);


  if(status ==='loading'){
    return <>loading</>;
  }
  
  const copyData = ()=>{
    if(allFruitWithFormat.length===0){
      return '';
    }
    else{
      const title = `You have messaged ${allFruitWithFormat.length} fishes 😌. Let's catch them!`;
      return [title,...allFruitWithFormat].join('\n');
    }
  };

  console.log('textCounter',textCounter);
  const allFruitWithFormat = textCounter===undefined?[]: textCounter.fishes!=null?Object.keys(textCounter.fishes).map(keys=> '- '+ _.startCase(_.toLower(textCounter.fishes[keys].name))):[];
  const telegramReport = ()=>{
    if(textCounter===undefined){
      useAlert('You haven\'t texted anyone.','warning');
    }
    else if (user.telegramId) {
      setTelegramReportLoading(true);
      telegramMessage(user.telegramId, `You have messaged ${textCounter.textCount} fishes 😌. Let's catch them!.`)
        .then(() => {

          const telegramMessagePromises = sliceIntoChunks(allFruitWithFormat, 50).map(x=>{
            return telegramMessage(user.telegramId,
              x.join('%0A')
            );
          });
          console.log('telegramMessagePromises',telegramMessagePromises);

          Promise.all(telegramMessagePromises)
            .then(()=>{
              useAlert('Telegram Report has been sent','success');
              setTelegramReportLoading(false);
            })
            .catch((error)=>{
              useErrorAlert('Telegram Report can`t be sent',error);
              setTelegramReportLoading(false);
            });
        })
        .catch((error)=>{
          useErrorAlert('Telegram Report can`t be sent',error);
          setTelegramReportLoading(false);
        });
    }
    else{
      console.log('This user would not recieve a telegram message, because it doesn\'t have a Telegram ID');
    }
  };
  return (

    <Card>
      <Box p={2}>
        <Box p={2} style={{ textAlign: 'center' }}>
          <Typography variant="h2">{textCounter===undefined?0:textCounter?.textCount??0}</Typography>
          <Typography variant="body1" gutterBottom>
                Online Texting
          </Typography>
        </Box>
        <Box p={2} style={{ textAlign: 'center' }}>
          <Typography variant="h2">{textCounter===undefined?0:textCounter.offlineFishingCount}</Typography>
          <Typography variant="body1" gutterBottom>
                Offline Fishing
          </Typography>
        </Box>

        <Badge
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          style={{
            width: '100%',
            marginBottom: 8
          }}
          color="secondary"
        >
          <Box
            pb={5}
            style={{
              width: '100%'
            }}
          >
            {user.telegramId&&( 
              <Button
                color="primary"
                startIcon={ <TelegramIcon/>}
                variant="contained"
                disabled={telegramReportLoading}
                style={{
                  width: '100%',
                  background:
                      'linear-gradient(144deg, rgba(16,157,89,1) 0%, rgba(0,136,204,1) 100%)',
                  color: 'white'
                // filter: "saturate(0.3)"
                }}
                // onClick={() => alert("This feature is in maintaince")}
                onClick={() => telegramReport()}
              >
             Telegram Report {telegramReportLoading&& <CircularProgress size={16} style={{ marginLeft:8,color: 'white' }}/>}
              </Button>)}
           
            <CopyToClipboard text={copyData()}>
              <Button
                color="secondary"
                variant="contained"
                startIcon={<ContentCopyIcon/>}
                style={{
                  width: '100%',
                  marginTop:8,
                  color: 'white'
                }}
                // onClick={() => alert("This feature is in maintaince")}
                onClick={() => {
                  if(textCounter===undefined){
                    useAlert('You haven\'t texted anyone.','warning');
                  }
                  else{
                    useAlert('Report has been copied to clipboard','success');
                  }
                }}
              >
                  Copy report
              </Button>
            </CopyToClipboard>
          </Box>
              
        </Badge>
 
     
        <br />
        <hr></hr>
        <Typography variant="caption" gutterBottom>
              Seem like you got some questions, advice, difficulties with
              this tool?{' '}
          <a
            style={{ color: '#0088cc' }}
            href="https://docs.google.com/forms/d/e/1FAIpQLSeB0p5f6Luu2Pgr1NEceBLLJO4OTGp1cry70zlve2zI3TOQDA/viewform"
            target="__blank"
          >
                Let`s contact IT team
          </a>{' '}
              now.
        </Typography>
      </Box>
    </Card>
  );
};

